module.exports = __webpack_public_path__ + "img/about-us-top-bg.985ee847.png";